export default abstract class AbstractWrapperElement {
  abstract updateElementPosition(
    pos: {
      top: number;
      left: number;
      width: number;
      height: number;
    },
    iframeRect: {
      top: number;
      left: number;
      width: number;
      height: number;
    }
  ): void;
}
